import React, { useEffect, useState } from 'react';
import { connect } from 'umi';
import { isEmpty } from 'lodash';
import { Form, Input } from 'antd';
import { Popup, CheckList } from 'antd-mobile';
import { Text, Modal, Button } from '@digitalc/dxp-ui';
import { CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { onHistoryPush } from '@/utils/utils';
import useGCPI18n from '@/hooks/useGCPI18n';
import useResponsive from '@/hooks/useResponsive';
import { Clickable } from '@/components';
import transfer from '@/assets/images/point/transfer.png';
import dorpDown from '@/assets/images/Group.png';
import convertFail from '@/assets/images/point/convertFail.png';
// import { BaseSpin } from '@/components';
import Header from '../Header';
import styles from './index.less';

const TransferInputBox = styled.div`
  height: 100%;
  font-family: ${theme => theme.$dxpToken.fontFamilySecondaryRegular};
  .ant-input-affix-wrapper {
    border: 1px solid ${theme => theme.$dxpToken.colorBorderStandard};
    background-color: ${theme => theme.$dxpToken.colorBackgroundStandard};
    padding: 0rem ${theme => theme.$dxpToken.spacingInputMd / 100}rem;
    border-radius: ${theme => theme.$dxpToken.borderRadiusSm / 100}rem;
  }
  :where(.css-dev-only-do-not-override-mc1tut).ant-input {
    padding: 0rem ${theme => theme.$dxpToken.spacingInputMd / 100}rem;
    border-radius: ${theme => theme.$dxpToken.borderRadiusSm / 100}rem;
  }
  .ant-input-disabled {
    background-color: ${theme => theme.$dxpToken.colorBackgroundSubtle};
  }
  .ant-form-item {
    margin-bottom: ${theme => theme.$dxpToken.spacingGapMd};
  }
`;
const TransferPopupBox = styled.div`
  .adm-list {
    --border-top: none;
  }
  .adm-list-item-content {
    padding-right: 0;
  }
  .adm-list-item {
    font-family: ${theme => theme.$dxpToken.fontFamilySecondaryRegular};
    color: ${theme => theme.$dxpToken.colorTextNeutral};
    padding-left: 0;
    font-weight: 400;
    line-height: 1.5;
    font-size: ${theme => theme.$dxpToken.fontSizeMobileContentC14 / 100}rem;
  }
  .adm-check-list-item-active {
    color: ${theme => theme.$dxpToken.colorBackgroundCta} !important;
    background-color: #fff;
  }
  .adm-list-item-content-main {
    padding: ${theme => theme.$dxpToken.spacingGapMd / 100}rem 0;
  }
  .adm-check-list-item-extra {
    color: ${theme => theme.$dxpToken.colorBackgroundCta} !important;
  }
  a.adm-list-item:active:not(.adm-list-item-disabled) {
    color: ${theme => theme.$dxpToken.colorBackgroundCta} !important;
    background-color: #fff;
  }
  .adm-list-item-content {
    padding-right: 0;
  }
`;
const PointsTransfer = props => {
  // 响应式 hook
  useResponsive();
  const { getConfigParamDXP, pointTransferDXP, transferPointList, dxpToken, pointTransferLimits } =
    props;
  // const { formatMessage } = useIntl();
  const [form] = Form.useForm();
  const reg = /^\d*(\.\d*)?$/;
  const { validateFields } = form;
  const [phoneRegex, setPhoneRegex] = useState('');
  const [displayScale, setDisplayScale] = useState(0);
  const [lastDisplayScale, setLastDisplayScale] = useState('');
  const [formInfo, setFormInfo] = useState({});
  const [show, setShow] = useState(false);
  const [hasFail, setHasFail] = useState(false);
  const [isTransfering, setIsTransfering] = useState(false);
  const [selectPointVisible, setSelectPointVisible] = useState(false);
  const [pointsList, setPointList] = useState([]);
  const [tempSelectPoint, setTempSelectPoint] = useState({});
  const [selectPoint, setSelectPoint] = useState({});
  const [disabled, setDisabled] = useState(true); // 按钮禁用
  const [limit, setLimit] = useState(null); // 单笔限额
  const GCPI18n = useGCPI18n();

  /**
   * Render a select input with dropdown icon
   * @param {Object} params
   * @param {string} params.name - Form field name
   * @param {string} params.labelI18nId - Label i18n ID
   * @param {string} params.placeholderI18nId - Placeholder i18n ID
   */
  const renderSelectInput = ({ name, labelI18nId, placeholderI18nId }) => (
    <Form.Item
      name={name}
      label={GCPI18n({ id: labelI18nId })}
      rules={[
        {
          required: true,
          message: GCPI18n({ id: 'lb_point_field_required' }),
        },
      ]}
    >
      <Input
        placeholder={GCPI18n({ id: placeholderI18nId })}
        onClick={() => setSelectPointVisible(true)}
        suffix={
          <Clickable as="img" src={dorpDown} alt="" onClick={() => setSelectPointVisible(true)} />
        }
      />
    </Form.Item>
  );

  const handleOpenConfirmModal = async () => {
    const formInfoTemp = await validateFields();
    setFormInfo(formInfoTemp);
    setShow(true);
  };
  const values = form.getFieldsValue();
  useEffect(() => {
    // setFieldsValue 不会触发 onFieldsChange 和 onValuesChange
    if (!isEmpty(values)) {
      const { receiver, pointValue } = values;
      // 检查是否超过限额
      const exceedsLimit = limit && pointValue && Number(pointValue) > Number(limit);
      if (receiver && pointValue && !exceedsLimit) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    }
  }, [values, limit]);

  // 对该按钮增加防抖功能
  const handleSubmit = async () => {
    // const formInfo = form.getFieldsValue();
    if (isTransfering) {
      return;
    }
    setIsTransfering(true);
    const pointTransferNow = pointTransferDXP;
    const payload = {
      receiver: formInfo.receiver,
      transferType: 'SUBS_MSISDN',
      pointAcctTypeCode: selectPoint?.acctTypeCode,
      pointValue: formInfo.pointValue,
    };
    pointTransferNow(payload).then(res => {
      if (isEmpty(res)) {
        setHasFail(true);
      } else {
        onHistoryPush('/pointshop/SuccessPage', {
          type: 'Transfer',
          receiver: res?.receiver,
          PointsType: selectPoint?.acctTypeName,
          pointValue: res?.transferPointValue,
          transferor: res?.transferor,
        });
      }
      setShow(false);
      setIsTransfering(false);
    });
  };

  // 用于处理输入，只允许数字和小数点
  const handleInputChange = e => {
    const { value } = e.target;
    if (reg.test(value) || value === '') {
      form.setFieldsValue({ pointValue: value });
      setLastDisplayScale(value);
    } else {
      form.setFieldsValue({ pointValue: lastDisplayScale });
    }
  };

  // 处理失去焦点事件，根据 displayScale 截取多余的小数位数
  const handleBlur = () => {
    const value = form.getFieldValue('pointValue');
    if (value && reg.test(value)) {
      // const numValue = parseFloat(value).toFixed(displayScale);
      // form.setFieldsValue({ pointValue: numValue });
      // setLastDisplayScale(numValue);
      const [integerPart, decimalPart] = value.split('.');
      if (decimalPart && decimalPart.length > displayScale) {
        // 截取小数部分到指定的 displayScale 长度
        const truncatedValue = `${integerPart}.${decimalPart.substring(0, displayScale)}`;
        form.setFieldsValue({ pointValue: truncatedValue });
        setLastDisplayScale(truncatedValue);
      } else {
        // 如果小数部分长度不超过 displayScale 或没有小数部分
        form.setFieldsValue({ pointValue: value });
        setLastDisplayScale(value);
      }
    }
    // validateFields();
    // 这会校验所有的表单字段
    validateFields(['pointValue']);
  };

  const handlePhoneChange = e => {
    const { value } = e.target;

    if (!new RegExp(/^\d*$/).test(value)) {
      // 如果输入不符合要求，则不更新表单值
      form.setFieldsValue({ receiver: value.replace(/\D/g, '') });
    }
  };

  const handleOtpCancel = () => {
    setShow(false);
  };

  const handleErrHome = () => {
    onHistoryPush('/pointshop/pointsH5');
  };

  const handleTryClick = () => {
    setHasFail(false);
  };

  useEffect(() => {
    getConfigParamDXP({ paramCodeList: ['CONTACT_NUMBER_REGEX'] }).then(res => {
      if (res) {
        setPhoneRegex(res.paramValue);
      }
    });
    getConfigParamDXP({ paramCodeList: ['lms.point.precision'] }).then(res => {
      const jsonObj = JSON.parse(res.paramValue || '{}');
      setDisplayScale(jsonObj?.displayScale || 0);
    });

    transferPointList().then(res => {
      if (res?.resultCode === '0') {
        setPointList(res?.data || []);
        if (res?.data.length > 0) {
          setSelectPoint(res.data[0]);
          setTempSelectPoint(res.data[0]);
          form.setFieldsValue({ transType: res.data[0]?.acctTypeName });
        }
      }
    });

    pointTransferLimits({
      limitType: 'kpiPointTransferIn',
    }).then(res => {
      const limitTemp = res?.[0]?.amountValue || null;
      if (limitTemp) {
        setLimit(Number(limitTemp));
      }
    });
  }, []);

  return (
    <TransferInputBox $dxpToken={dxpToken}>
      <div className={styles.pointsTransfer}>
        <Header
          // title={GCPI18n({
          //   id: 'HEADER_MY_POINT_HISOTRY',
          // })}
          title={GCPI18n({
            id: 'lb_conversion_points_transfer',
          })}
          notNewPage
        />
        <Form
          name="basic"
          autoComplete="off"
          form={form}
          colon={false}
          layout="vertical"
          style={{ color: dxpToken.colorTextNeutral }}
        >
          <Form.Item
            name="receiver"
            label={GCPI18n({
              id: 'lb_point_transfer_number',
            })}
            rules={[
              {
                required: true,
                message: GCPI18n({
                  id: 'lb_point_field_required',
                }),
              },
              () => ({
                validator(_, value) {
                  let reject = null;
                  try {
                    if (value && !new RegExp(phoneRegex).test(value)) {
                      reject = Promise.reject(
                        new Error(
                          GCPI18n({
                            id: 'lb_point_transfer_number_valid',
                          }),
                        ),
                      );
                    } else {
                      reject = Promise.resolve();
                    }
                  } catch (error) {
                    reject = Promise.resolve();
                  }
                  return reject;
                },
              }),
            ]}
          >
            <Input
              placeholder={GCPI18n({
                id: 'lb_point_transfer_number_placeholder',
              })}
              suffix={<img src={transfer} alt="" />}
              onChange={handlePhoneChange}
              // value={smsCode}
              // type="number"
            />
          </Form.Item>
          {renderSelectInput({
            name: 'transType',
            labelI18nId: 'lb_transfer_type',
            placeholderI18nId: 'lb_conversion_select',
          })}
          <Form.Item
            name="pointValue"
            label={GCPI18n({
              id: 'lb_point_remount',
            })}
            rules={[
              {
                required: true,
                message: GCPI18n({
                  id: 'lb_point_field_required',
                }),
              },
              () => ({
                validator(_, value) {
                  if (limit && value && Number(value) > Number(limit)) {
                    return Promise.reject(
                      // new Error(
                      //   `Exceeding the maximum transfer point limit of ${limit}`,
                      // ),
                      new Error(GCPI18n('lb_point_transfer_amount_limit', { pointValue: limit })),
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input
              placeholder={GCPI18n({
                id: 'lb_point_remount_placeholder',
              })}
              onChange={handleInputChange}
              onBlur={handleBlur}
              status={
                limit && values.pointValue && Number(values.pointValue) > Number(limit)
                  ? 'error'
                  : ''
              }
              // onChange={checkValue}
              // value={smsCode}
              // type="number"
            />
          </Form.Item>
        </Form>
        <div className={styles.orderFooter} style={{ padding: dxpToken.spacingGapLg }}>
          <div className={styles.footerBox}>
            <div className={styles.orderSubmit}>
              <Button
                type="primary"
                block
                // onClick={handleModalSubmit}
                className={styles.submitBtn}
                onClick={handleOpenConfirmModal}
                disabled={disabled}
                style={!disabled && { color: '#ffffff' }}
                // inventoryNum 为 null 是没关联库存，可以订购，不为null且小于等于0是没有库存，不可以订购
                // disabled={
                //   get(skuListItem, 'pointPrice') > Number(get(pointDetail, 'usablePoint')) ||
                //   (get(skuListItem, 'inventoryNum') && get(skuListItem, 'inventoryNum') <= 0)
                // }
              >
                {GCPI18n({
                  id: 'lb_point_transfer',
                })}
              </Button>
            </div>
          </div>
          <Clickable
            style={{ marginTop: dxpToken.spacingIconMd, textAlign: 'center' }}
            // className={styles.footerCancel}
            onClick={() => {
              onHistoryPush('/pointshop/pointsH5');
            }}
          >
            <Text breakpoint="Mobile" size="ContentC14TextLink">
              {GCPI18n({
                id: 'btn_cancel',
              })}
            </Text>
          </Clickable>
        </div>
        {selectPointVisible && (
          <Popup
            visible={selectPointVisible}
            showCloseButton={false}
            bodyStyle={{
              borderTopLeftRadius: '0.16rem',
              borderTopRightRadius: '0.16rem',
              padding: '0.24rem 0.16rem',
              height: 'auto',
              maxHeight: '100% ',
            }}
          >
            <TransferPopupBox $dxpToken={dxpToken}>
              <div className={styles.content}>
                <div className={styles.popupHeader}>
                  <div
                    className={styles.title}
                    style={{
                      fontFamily: dxpToken.fontFamilyPromaryBold,
                      color: dxpToken.colorTextNeutral,
                      fontSize: dxpToken.fontSizeMobileTitleT21,
                    }}
                  >
                    {GCPI18n({ id: 'lb_transfer_type' })}
                  </div>
                  <CloseOutlined
                    style={{ fontSize: '0.24rem' }}
                    onClick={() => {
                      setSelectPointVisible(false);
                    }}
                  />
                </div>
                <CheckList
                  style={{
                    margin: `${dxpToken.spacingGapLg / 100}rem 0`,
                  }}
                  defaultValue={[selectPoint?.acctTypeCode]}
                  onChange={val => {
                    // 只有confirm才生效
                    const tempList = pointsList.filter(item => item?.acctTypeCode === val[0]);
                    setTempSelectPoint(tempList[0]);
                  }}
                >
                  {pointsList.map(item => (
                    <CheckList.Item key={item?.acctTypeCode} value={item?.acctTypeCode}>
                      {item?.acctTypeName}
                    </CheckList.Item>
                  ))}
                </CheckList>
                <div className={styles.confirmBtn}>
                  <Button
                    type="primary"
                    block
                    style={{ color: '#ffffff' }}
                    onClick={() => {
                      setSelectPoint({ ...tempSelectPoint });
                      form.setFieldsValue({ transType: tempSelectPoint?.acctTypeName });
                      setSelectPointVisible(false);
                    }}
                  >
                    {GCPI18n({
                      id: 'btn_confirm',
                    })}
                  </Button>
                </div>
              </div>
            </TransferPopupBox>
          </Popup>
        )}
        {/* {show && (
        <Modal
          width="3.1rem"
          className={styles.pointsModal}
          open={show}
          onCancel={handleOtpCancel}
          footer={null}
          centered
          closable={false}
        >
          <BaseSpin spinning={loading}>
            <div className={styles.redeemTitle}>
              Would you like to transfer <span className={styles.highlight}>{formInfo.pointValue}</span> points to
              <span className={styles.highlight}> {formInfo.receiver}</span>
            </div>
            <div className={styles.redeemBtn}>
              <Button onClick={handleOtpCancel}>{GCPI18n({ id: 'POINTS_CANCEL' })}</Button>
              <Button type="primary" onClick={handleSubmit}>
                {GCPI18n({ id: 'POINTS_CONFIRM' })}
              </Button>
            </div>
          </BaseSpin>
        </Modal>
      )} */}
        {show && (
          <Modal
            breakpoint="mobile"
            size="50%"
            title={GCPI18n({
              id: 'lb_conversion_points_transfer',
            })}
            open={show}
            onCancel={handleOtpCancel}
            // loading={modalLoading}
            footer={(
              <div style={{ display: 'flex', gap: '0.08rem' }}>
                <Button className={styles.cancel} onClick={handleOtpCancel}>
                  {GCPI18n({ id: 'btn_cancel' })}
                </Button>
                <Button type="primary" onClick={handleSubmit} className={styles.primary}>
                  {GCPI18n({
                    id: 'lb_point_transfer',
                  })}
                </Button>
              </div>
            )}
          >
            <Text breakpoint="Mobile" size="ContentC14Regular">
              {GCPI18n('lb_point_transfer_tip', {
                pointValue: <span className={styles.highlight}>{formInfo.pointValue}</span>,
                receiver: <span className={styles.highlight}> {formInfo.receiver}</span>,
              })}
            </Text>
          </Modal>
        )}
        {/* {hasFail && (
        <Modal width="3.1rem" className={styles.pointsModal} visible footer={null} centered closable={false}>
          <div className={styles.errImg}>
            <img src={convertFail} alt="" />
          </div>
          <div className={styles.errName}>{GCPI18n({ id: 'POINT_UNSUCCESSFUL' })}</div>
          <div className={styles.errBtn}>
            <Button onClick={handleErrHome}>{GCPI18n({ id: 'POINT_POINT_MALL' })}</Button>
            <Button type="primary" onClick={handleTryClick}>
              {GCPI18n({ id: 'DITO_FAILED_PAGE_TRY_AGAIN' })}
            </Button>
          </div>
        </Modal>
      )} */}
        {hasFail && (
          <Modal
            breakpoint="mobile"
            size="50%"
            open={hasFail}
            onCancel={() => {
              setHasFail(false);
            }}
            className={styles.pointsModal}
            footer={(
              <div style={{ display: 'flex', gap: '0.08rem' }}>
                <Button className={styles.cancel} onClick={handleErrHome}>
                  {GCPI18n({ id: 'lb_point_point_mall' })}
                </Button>
                <Button type="primary" onClick={handleTryClick} className={styles.primary}>
                  {GCPI18n({ id: 'lb_dito_failed_page_try_again' })}
                </Button>
              </div>
            )}
            // className={styles.pointsModal} open footer={null} centered closable={false}
          >
            <div className={styles.contentWrap}>
              <div className={styles.errImg}>
                <img src={convertFail} alt="" />
              </div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Text breakpoint="Mobile" size="TitleT23Bold" style={{ fontFamily: 'Roboto' }}>
                  {GCPI18n({ id: 'lb_transfer_fail' })}
                </Text>
              </div>
            </div>
          </Modal>
        )}
      </div>
    </TransferInputBox>
  );
};

const mapDispatchToProps = dispatch => ({
  getConfigParamDXP: payload =>
    dispatch({
      type: 'index/getConfigParamDXP',
      payload,
    }),
  pointTransferDXP: payload =>
    dispatch({
      type: 'index/pointTransferDXP',
      payload,
    }),
  pointTransferLimits: payload =>
    dispatch({
      type: 'index/pointTransferLimits',
      payload,
    }),
  transferPointList: payload =>
    dispatch({
      type: 'pointShop/transferPointList',
      payload,
    }),
});

export default connect(
  ({ pointShop, loading, index }) => ({
    changeHis: pointShop.changeHis,
    pointDetail: pointShop.pointDetail,
    dxpToken: index.dxpToken,
    loading: loading.effects['pointShop/pointTransfer'] || false,
  }),
  mapDispatchToProps,
)(PointsTransfer);
